// A person on a temporary password (debeCambiarPassword) may pick their own
// through a reset link (welcome e-mail or "Olvidé mi contraseña") instead of
// the first-login change. Firebase Auth has no trigger for that, so the
// client asks sincronizarClave to re-check; the server decides alone, from
// Auth's passwordUpdatedAt against its own marker, so these calls only
// trigger the check and are best effort.
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { callables } from '@/datos/acciones';
import { auth } from './firebase';
import { leerSesion, publicar, type SesionActiva } from './sesion';

/**
 * Right after /accion saved the new password: sign in with it just for the
 * check, then sign out (the page then says "ingresa con tu nueva
 * contraseña", as before). Never replaces another account's open session in
 * this browser. If anything fails, the check at the first sign-in covers it.
 */
export async function avisarClaveElegida(email: string, password: string): Promise<void> {
  try {
    const abierta = auth.currentUser;
    if (abierta && abierta.email?.toLowerCase() !== email.toLowerCase()) return;
    const { user } = await signInWithEmailAndPassword(auth, email, password);
    try {
      const token = await user.getIdTokenResult();
      if (token.claims['debeCambiarPassword'] === true) await callables.sincronizarClave({});
    } finally {
      await signOut(auth);
    }
  } catch {
    // Best effort (see above).
  }
}

/**
 * Before the first-login change (/cambiar-clave): true when the server says
 * the password is already the person's own. The session is re-read with a
 * fresh token so the router sees the new claims.
 */
export async function claveYaElegida(s: SesionActiva): Promise<boolean> {
  try {
    const r = await callables.sincronizarClave({});
    if (r.debeCambiarPassword) return false;
    publicar(await leerSesion(s.usuario, true));
    return true;
  } catch {
    return false;
  }
}
